import { number, string } from 'prop-types'

export default {
  id: string,
  tooltip: string,
  x: number.isRequired,
  y: number.isRequired
}
